import moment from 'moment';
import axios from 'axios';

let localStorage = window.localStorage;

let boeking = null;
let data = null;
const state = {
    objectsoortIdZoeken: 0
};

// getters
const getters = {
    getLocalStorageItem(name, defaultValue = null) {
        let item = localStorage.getItem(name);
        if (item == null) return defaultValue;
        return JSON.parse(item);
    },

    getLocalStorageData() {
        data = Object();
        data.volwassenen = getters.getLocalStorageItem('volwassenen', 2);
        data.jongvolwassenen = getters.getLocalStorageItem('jongvolwassenen', 0);
        data.kinderen = getters.getLocalStorageItem('kinderen', 0);
        data.babys = getters.getLocalStorageItem('babys', 0);

        data.dateStart = getters.getLocalStorageItem('dateStart', moment().format('DD-MM-YYYY'));
        if (moment(data.dateStart, 'DD-MM-YYYY').diff(moment(), 'days') < 0) {
            let resettedDateStart = moment().format('DD-MM-YYYY');
            localStorage.setItem('dateStart', JSON.stringify(resettedDateStart));
            data.dateStart = resettedDateStart;
        }

        data.dateEnd = getters.getLocalStorageItem(
            'dateEnd',
            moment()
                .add(1, 'days')
                .format('DD-MM-YYYY')
        );
        if (moment(data.dateEnd, 'DD-MM-YYYY').diff(moment(), 'days') < 1) {
            let resettedDateEnd = moment()
                .add(1, 'days')
                .format('DD-MM-YYYY');
            localStorage.setItem('dateEnd', JSON.stringify(resettedDateEnd));
            data.dateEnd = resettedDateEnd;
        }

        data.ingevoerd = getters.getLocalStorageItem('ingevoerd', false);
        data.objectTypeId = getters.getLocalStorageItem('objectTypeId', 0);
        data.objectSoortId = getters.getLocalStorageItem('objectSoortId', 0);
        data.objectNaam = getters.getLocalStorageItem('objectNaam', 0);
        data.objectDetailsIconText = getters.getLocalStorageItem('objectDetailsIconText', 0);
        data.reserveringsId = getters.getLocalStorageItem('reserveringsid', 0);
        data.reserveringStart = getters.getLocalStorageItem('reserveringStart', 0);
        data.reserveringEnd = getters.getLocalStorageItem('reserveringEnd', 0);

        return data;
    },

    getBoeking() {
        if (boeking == null) {
            boeking = Object();
            let filterData = actions.getFilterData();
            boeking.Personen = filterData.Personen;
            boeking.AankomstDatum = filterData.ReserveringsId ? filterData.ReserveringStart : filterData.AankomstDatum;
            boeking.VertrekDatum = filterData.ReserveringsId ? filterData.ReserveringEnd : filterData.VertrekDatum;
            boeking.ObjectTypeId = filterData.objectTypeId;
            boeking.ObjectSoortId = filterData.objectSoortId;
            boeking.ObjectNaam = filterData.objectNaam;
            boeking.ObjectId = '';
            boeking.Extras = '';
            boeking.TotaleKosten = null;
            boeking.BetalingsTermijnen = null;
            boeking.BetaalMethode = null;
            boeking.BeschikbareArtikelen = null;
            boeking.ReserveringsId = filterData.reserveringsId;
            boeking.GekozenLocatie = localStorage.getItem('zelfgekozen') ? localStorage.getItem('gekozenlocatie') : null;
            boeking.GastGegevens = {
                IdAanhef: getters.getLocalStorageItem('GastGegevens_IdAanhef', null),
                country: getters.getLocalStorageItem('GastGegevens_country', null),
                dateOfBirth: getters.getLocalStorageItem('GastGegevens_dateOfBirth', null),
                firstName: getters.getLocalStorageItem('GastGegevens_firstName', null),
                prefix: getters.getLocalStorageItem('GastGegevens_prefix', null),
                lastName: getters.getLocalStorageItem('GastGegevens_lastName', null),
                street: getters.getLocalStorageItem('GastGegevens_street', null),
                number: getters.getLocalStorageItem('GastGegevens_number', null),
                zip: getters.getLocalStorageItem('GastGegevens_zip', null),
                city: getters.getLocalStorageItem('GastGegevens_city', null),
                phone: getters.getLocalStorageItem('GastGegevens_phone', null),
                email: getters.getLocalStorageItem('GastGegevens_email', null),
                comments: getters.getLocalStorageItem('GastGegevens_comments', null),
                news: getters.getLocalStorageItem('GastGegevens_news', false)
            };

            boeking.ReserveringsCategorie = 1002;
            boeking.LocatieIsZelfGekozen = getters.getLocalStorageItem('zelfgekozen', false);
            boeking.ActieCode = getters.getLocalStorageItem('actiecode', null);
            // Aankomst tijd
            if (Number(boeking.ObjectSoortId) === 1002) {
                if (Number(boeking.ObjectTypeId) === 1002) {
                    boeking.AankomstTijd = '14:00';
                } else {
                    boeking.AankomstTijd = '13:00';
                }
            } else {
                boeking.AankomstTijd = '16:00';
            }

            // Vertrektijd
            if (Number(boeking.ObjectSoortId) === 1002) {
                boeking.VertrekTijd = '11:00';
            } else {
                boeking.VertrekTijd = '10:00';
            }
        }
        return boeking;
    }
};

// actions
const actions = {
    clearLocalStorage() {
        localStorage.removeItem('actiecode');
        localStorage.removeItem('zelfgekozen');
        localStorage.removeItem('reserveringsid');
        localStorage.removeItem('objectLocatie');
        localStorage.removeItem('sessie');
    },

    setLocalStorageData({ state, commit, rootState }, data) {
        commit('setLocalStorageData', data);
    },

    getFilterData() {
        data = Object();
        let localStorageData = getters.getLocalStorageData();
        data.Personen = {
            volwassenen: localStorageData.volwassenen,
            jongvolwassenen: localStorageData.jongvolwassenen,
            kinderen: localStorageData.kinderen,
            babys: localStorageData.babys
        };
        data.AankomstDatum = localStorageData.dateStart;
        data.VertrekDatum = localStorageData.dateEnd;
        data.ReserveringStart = localStorageData.reserveringStart;
        data.ReserveringEnd = localStorageData.reserveringEnd;
        data.ObjectTypeId = localStorageData.objectTypeId;
        data.ObjectSoortId = localStorageData.objectSoortId;
        data.ObjectNaam = localStorageData.objectNaam;
        data.ReserveringsId = localStorageData.reserveringsId;
        return data;
    }
};

// mutations
const mutations = {
    setLocalStorageData(state, data) {
        if (data.isUmsRelated && !data.value && (data.key === 'volwassenen' || data.key === 'jongvolwassenen' || data.key === 'kinderen' || data.key === 'babys')) {
            // convert empty value for person numbers to 0
            data.value = 0;
        }

        if (!data.value && data.value !== 0) {
            // remove item from localStorage
            localStorage.removeItem(data.key);
        } else {
            // set item to localStorage
            localStorage.setItem(data.key, JSON.stringify(data.value));

            // set cookie (except for accommodatietype = 0)
            if (data.isUmsRelated && (data.key !== 'accommodatietype' || data.value !== 0)) {
                var date = new Date();
                date.setTime(date.getTime() + 28 * 24 * 60 * 60 * 1000); // lifetime of 28 days
                let expires = '; expires=' + date.toUTCString();
                document.cookie = 'frUmsVisitorData_' + data.key + '=' + data.value + expires + '; path=/';
            }
        }
    },
    setBoeking(state, boeking) {
        this.boeking = boeking;
    },
    setObjectSoortIdZoeken(state, id) {
        state.objectsoortIdZoeken = id;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
